import axios, { AxiosResponse } from 'axios';
import { get } from 'lodash-es';
import { DefaultOptionType } from 'rc-select/lib/Select';
import { useEffect, useState } from 'react';

import { ConsumerInterface } from '@interface/consumer/consumer.interface';
import { CredentialInterface } from '@interface/credential/credential.interface';
import { ResponseDataInterface } from '@interface/logs/response-data.interface';
import { isString } from '@util/data/is-exist';

const loadData = <T>(url: string, cb: (data: AxiosResponse<ResponseDataInterface<T[]>>) => void) =>
  axios({
    url,
    method: 'GET',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  }).then(cb);

export const useExplorerVarsHeader = (applicationId: string, apiKey: string) => {
  const [credentials, setCredentials] = useState<DefaultOptionType[]>([]);
  const [consumers, setConsumers] = useState<DefaultOptionType[]>([]);
  const [applications, setApplication] = useState<DefaultOptionType[]>([]);

  useEffect(() => {
    if (!localStorage.getItem('token')) return;

    void loadData<ConsumerInterface>(`${import.meta.env.VITE_API_PORTAL_URL}/applications/`, ({ data }) =>
      setApplication(data.data.map((item) => ({ value: item.id, label: item.name }))),
    );

    void loadData<CredentialInterface>(
      `${import.meta.env.VITE_API_PORTAL_URL}/credentials/all?limit=1000`,
      ({ data }) => setCredentials(data.data),
    );
  }, []);

  useEffect(
    () =>
      void (
        isString(applicationId) &&
        isString(apiKey) &&
        axios({
          url: `${import.meta.env.VITE_AUTH_SERVICE_BASE_URL}`,
          method: 'POST',
          data: {
            apiKey,
            applicationId,
            scope: 'application',
          },
        })
          .then((result) =>
            axios({
              url: `${get(result, ['data', 'data', 'url'])}/api/consumers`,
              method: 'GET',
              headers: {
                Authorization: `Bearer ${get(result, ['data', 'data', 'accessToken'])}`,
              },
              params: {
                applicationId,
              },
            }),
          )
          .then((result) =>
            setConsumers(get(result, ['data', 'data'], []).map((item: any) => ({ value: item.id, label: item.name }))),
          )
          .catch(() => setConsumers([]))
      ),
    [applicationId, apiKey],
  );

  return {
    credentials: credentials
      .filter((credential) => {
        if (!isString(applicationId)) return true;

        return credential.application.id === applicationId;
      })
      .map((item) => ({ value: item.apiKey, label: item.apiKey })),
    consumers,
    applications,
  };
};
